import { LoadState } from "../../constants/enums";
import { coverageData as automobileCoverageData } from "../automobileSchedule/automobileSchedule.types";

export interface QuoteSettingsState {
  defaultCoverage: {
    coverageList: QuoteDefaultCoverage[];
    coverage: QuoteDefaultCoverage;
    loading: LoadState;
    error: string | null;
  };
  defaultRemarks: {
    remarksList: QuoteDefaultRemarks[];
    remarks: QuoteDefaultRemarks;
    loading: LoadState;
    error: string | null;
  };
}

export interface QuoteDefaultCoverage {
  default_coverage_code: string | null;
  line_of_business: string | null;
  default_coverage_name: string | null;
  coverage_details: IAutomobileScheduleCoverage[];
  status: string;
}
export interface QuoteDefaultRemarks {
  remarks_template_code: string | null;
  remarks_template_name: string | null;
  remarks: string | null;
  status: string;
}

export interface IAutomobileScheduleCoverage {
  key: string;
  code: string;
  deductible: string | null;
  description: string | null;
  label: string;
  isTypeOther: boolean;
  isOnlyPremimum: boolean;
  limit: string | null;
  premimum: string | null;
  isDeductible: boolean;
}

export const coverageData: IAutomobileScheduleCoverage[] = automobileCoverageData;

export const INITIAL_DEFAULT_COVERAGE_STATE: QuoteDefaultCoverage = {
  default_coverage_code: null,
  line_of_business: null,
  default_coverage_name: null,
  coverage_details: coverageData,
  status: "ACTIVE",
};
export const INITIAL_DEFAULT_REMARKS_STATE: QuoteDefaultRemarks = {
  remarks_template_code: null,
  remarks_template_name: null,
  remarks: null,
  status: "ACTIVE",
};

export const initialQuoteSettingsState: QuoteSettingsState = {
  defaultCoverage: {
    coverageList: [],
    coverage: INITIAL_DEFAULT_COVERAGE_STATE,
    loading: LoadState.NotLoaded,
    error: null,
  },
  defaultRemarks: {
    remarksList: [],
    remarks: INITIAL_DEFAULT_REMARKS_STATE,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
